<template >
  <div class="Home">
    <!-- <div class="Home" style='overflow:-Scroll;overflow-y:hidden'> -->
    <Nav :navSelectParent="navSelectHome" />
    <div class="topDiv" id="topDiv">
      <img :src="topDiv" alt="" class="topDiving" />
      <img :src="fixedImg" alt="" class="fixedImg" @click="open" />
      <div class="qrcode">
        <div class="qrcodeContent">
          <div id="ios_btn">
            <img src="../assets/ios.png" alt="" id="QRcodeImg1" />
          </div>
          <div id="android_btn">
            <img src="../assets/android.png" alt="" id="QRcodeImg2" />
          </div>
        </div>
      </div>
      <img
        src="../assets/16+.png"
        alt=""
        class="sixteen"
        @click="dialogVisible = true"
      />
      <el-dialog
        title="提示说明:"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <p style='margin-bottom:8px;'>(1)本游戏是一款回合类型放置挂机类游戏，游戏内容适用于年满16周岁及以上的用户。</p>
        <p style='margin-bottom:8px;'>(2)本游戏基于架空的故事背景和世界观,剧情简单且积极向上，没有基于真实历史和现实事件所改编的内容。游戏玩法基于玩家点击操作,鼓励玩家通过任务进行成长达成目标,游戏中有基于文字的社交系统。</p>
        <p style='margin-bottom:8px;'>(3)根据国家相关要求,游戏中有用户实名认证系统，未通过实名认证的用户不可进入游戏;认证为未成年人的用户除周五、周六、周日及法定节假日每日20时至21时外其他时间均不可进入游戏。游戏中部分玩法和道具需要付费。根据腾讯健康系统管理规定,认证为未成年人的用户将接受以下管理:未满12周岁的用户不能付费;12周岁以上未满16周岁的未成年人用户，单次充值金额不得超过50元人民币,每月充值金欲系计个行超200元人民币;16周岁以上的未成年人用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。</p>
        <p>(4)本游戏的类型为自动挂机功能,玩家可以通过挂机放置轻松获得收益,降低节约用户的时间成本和负担。游戏内有社交功能以及组队玩法，需要玩家间进行社交和互相帮助配合,有助于培养玩家的沟通以及团队协作能力。</p>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span> -->
      </el-dialog>
      <div class="qrcodeFixed" v-if="down" @click="stop">
        <div class="qrcodeContentFixed">
          <div id="ios_btnFixed">
            <img src="../assets/ios.png" alt="" id="QRcodeImg1Fixed" />
          </div>
          <div id="android_btnFixed">
            <img src="../assets/android.png" alt="" id="QRcodeImg2Fixed" />
          </div>
        </div>
      </div>
    </div>
    <div class="middleNew" id="middleNew">
      <img :src="middleNew" alt="" style="width: 100vw" />
      <img :src="middleTop" alt="" class="middleTop" />
      <img :src="bgsamll" alt="" class="bgsamll" />
      <el-carousel
        indicator-position="outside"
        class="swiped"
        height="365px"
        id="swiped1"
        ref="carouselNews"
        @change="getChangeNews"
      >
        <el-carousel-item v-for="item in list1" :key="item.index">
          <img :src="item.img" alt="" />
        </el-carousel-item>
      </el-carousel>
      <ul class="carouselNews">
        <li
          v-for="(item, index) in list1"
          :key="index"
          @click="handleNews(index)"
        >
          <img :src="activeNews == index ? newImged : newImg" alt="" />
        </li>
      </ul>
      <div></div>
      <el-tabs
        v-model="activeName"
        class="new tab1"
        @tab-click="handleClick"
        ref="tabActive"
      >
        <el-tab-pane label="开服列表" name="first">
          <el-table :data="tableData1" style="width: 100%" max-height="460">
            <el-table-column prop="name" width="300"> </el-table-column>
            <el-table-column prop="date"> </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="游戏攻略" name="second">
          <el-table
            :data="tableData2"
            style="width: 100%"
            @row-click="openDetails"
            max-height="460"
          >
            <el-table-column
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              prop="name"
              width="300"
            >
            </el-table-column>
            <el-table-column prop="date"> </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="lunarDiv" id="lunarDiv">
      <img :src="tittle01" alt="" class="tittle01" />
      <img :src="lunarDiv" alt="" style="width: 100vw" />
      <img :src="leftIcon01" @click="handlePrev" class="leftIcon" />
      <el-carousel
        indicator-position="outside"
        class="swiped2"
        height="455px"
        type="card"
        :interval="4000"
        id="swiped2"
        ref="carouselCharacteristic"
        @change="getChange"
      >
        <el-carousel-item v-for="item in list2" :key="item.index">
          <img :src="item.img" alt="" style="background-size: 100% 100%" />
        </el-carousel-item>
      </el-carousel>
      <img :src="rightIcon" @click="handleNext" class="rightIcon" />
      <ul class="indicatorUl">
        <li
          v-for="(item, index) in list2"
          :key="item.index"
          @click="handleIndicator(index)"
        >
          <img
            :src="activeIndicatorIndex == index ? indicatored : indicatorImg"
            alt=""
          />
        </li>
      </ul>
    </div>
    <div class="gankebottom">
      <div class="ganke"><img :src="ganke" alt="" /></div>
      <div class="btnContent">
        <div>
          <p>未成年人家长监护工程&nbsp;&nbsp;</p>
          <P>网络游戏出版物号（ISBN）ISBN 978-7-498-07262-7</P>
        </div>
        <div>
          <p>审批文号：国新出审[2020]174 号&nbsp;&nbsp;</p>
          <a href="screct.html">隐私协议 |&nbsp;&nbsp;</a
          ><a href="https://sdk.djsh5.com/h5game/user/agreement.html"
            >用户协议 |&nbsp;&nbsp;</a
          ><a href="https://sdk.djsh5.com/h5game/user/antiaddiction.html"
            >防沉迷系统&nbsp;&nbsp;</a
          ><a href="https://beian.miit.gov.cn/#/Integrated/index">
            沪ICP备16037516号-1</a
          ><P>来文文号：津新出字[2019]232 号</P>
        </div>
        <div>
          <p>地址：上海市徐汇区虹漕路88号越虹广场B座6楼&nbsp;&nbsp;</p>
          <p>电话：021-64660150&nbsp;&nbsp;</p>
          <P>Email：bd@gank-studio.com</P>
        </div>
        <div>
          <p>
            抵制不良游戏，拒绝盗版游戏。 注意自我保护，谨防受骗上当。
            适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../components/nav.vue";
export default {
  name: "Home",
  components: {
    Nav,
  },
  data() {
    return {
      dialogVisible: false,
      activeNews: 0,
      navSelectHome: 0,
      activeIndicatorIndex: 0,
      down: false,
      activeName: "first",
      ganke: require("../assets/ganke.png"),
      topDiv: require("../assets/topDiv.jpg"),
      middle: require("../assets/middle.png"),
      middleNew: require("../assets/bgbig.png"),
      middleTop: require("../assets/title.png"),
      bgsamll: require("../assets/bgsamll.png"),
      lunarDiv: require("../assets/tsbg.png"),
      fixedImg: require("../assets/fixed.png"),
      // downImg: require("../assets/down.png"),
      tittle01: require("../assets/tittle01.png"),
      leftIcon01: require("../assets/left.png"),
      rightIcon: require("../assets/right.png"),
      indicatorImg: require("../assets/indicator.png"),
      indicatored: require("../assets/indicatored.png"),
      newImg: require("../assets/zdw.png"),
      newImged: require("../assets/zdwed.png"),
      list1: [
        {
          img: require("../assets/01.png"),
          index: "01",
        },
        {
          img: require("../assets/02.png"),
          index: "02",
        },
        {
          img: require("../assets/03.png"),
          index: "03",
        },
        {
          img: require("../assets/04.png"),
          index: "04",
        },
        {
          img: require("../assets/05.png"),
          index: "05",
        },
      ],
      list2: [
        {
          img: require("../assets/ts01.jpg"),
          index: "01",
        },
        {
          img: require("../assets/ts02.jpg"),
          index: "02",
        },
        {
          img: require("../assets/ts03.jpg"),
          index: "03",
        },
        {
          img: require("../assets/ts04.jpg"),
          index: "04",
        },
        {
          img: require("../assets/ts05.jpg"),
          index: "05",
        },
      ],
      tableData1: [
        {
          date: "2021/11/10 10:00",
          name: "雨巷大区1区",
        },
        {
          date: "2021/11/11 10:00",
          name: "雨巷大区2区",
        },
        {
          date: "2021/11/12 10:00",
          name: "雨巷大区3区",
        },
        {
          date: "2021/11/13 10:00",
          name: "雨巷大区4区",
        },
        {
          date: "2021/11/14 10:00",
          name: "雨巷大区5区",
        },
        {
          date: "2021/11/15 10:00",
          name: "雨巷大区6区",
        },
        {
          date: "2021/11/16 10:00",
          name: "雨巷大区7区",
        },
        {
          date: "2021/11/17 10:00",
          name: "雨巷大区8区",
        },
        {
          date: "2021/11/18 10:00",
          name: "雨巷大区9区",
        },
        {
          date: "2021/11/19 10:00",
          name: "雨巷大区10区",
        },
      ],
      tableData2: [
        {
          id: "01",
          date: "2021/7/10 10:00",
          name: "【攻略】萌新宝典√ 前期游戏小技巧",
        },
        {
          id: "02",
          date: "2021/7/9 10:00",
          name: "【光之圣境基本玩法】公会篇",
        },
        {
          id: "03",
          date: "2021/7/8 10:00",
          name: "【光之圣境基础玩法】命运之塔",
        },
        {
          id: "04",
          date: "2021/7/7 10:00",
          name: "【光之圣境放置次元】四大阵容体系：水系·雷系·火系·风系",
        },
      ],
    };
  },
  mounted() {
    var that = this;
    that.navSelectHome = that.$route.params.navSelect;
    window.addEventListener("scroll", function () {
      var wScrollY = window.scrollY; // 当前滚动条位置
      var topYXGL = document.querySelector("#middleNew").offsetTop;
      var topYXTS = document.querySelector("#lunarDiv").offsetTop;
      if (wScrollY < topYXGL) {
        that.navSelectHome = 0;
      } else if (wScrollY >= topYXGL && wScrollY < topYXTS) {
        that.navSelectHome = 1;
      } else if (wScrollY >= topYXTS) {
        that.navSelectHome = 2;
      }
    });
  },
  methods: {
    handleIndicator(index) {
      this.$refs.carouselCharacteristic.setActiveItem(index);
    },
    getChange(index) {
      // console.log('索引', index)
      this.activeIndicatorIndex = index;
    },
    handleNews(index) {
      this.$refs.carouselNews.setActiveItem(index);
    },
    getChangeNews(index) {
      this.activeNews = index;
    },
    handlePrev() {
      // 通过上边指定的ref 来操作
      this.$refs.carouselCharacteristic.prev();
    },
    handleNext() {
      this.$refs.carouselCharacteristic.next();
    },
    open: function () {
      this.down = !this.down;
    },
    stop: function () {
      this.down = !this.down;
    },
    openDetails(row) {
      // console.log('id为', row.id)
      var id = row.id;
      this.$router.push({ path: "/notice" + id });
    },
    handleClick(tab, event) {
      // console.log(tab, event)
      document.querySelector(".el-tabs__header").style.backgroundImage =
        this.activeName === "first"
          ? "url(" + require("../assets/zhishi01.png") + ")"
          : "url(" + require("../assets/zhishi02.png") + ")";
    },
    handleNavClick(item, index) {
      this.navSelectHome = index;
      var href = item.href;
      document.querySelector(href).scrollIntoView();
    },
  },
};
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.imgUrl {
  position: absolute;
  width: 100%;
  height: 88px;
  line-height: 88px;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 88px;
  padding: 0 10%;
  box-sizing: content-box;
}
.iconUl {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  box-sizing: content-box;
  width: 100%;
}
.iconUl li {
  list-style: none;
  align-items: center;
  width: 33.33%;
}
.topDiv {
  width: 100vw;
  margin: 0 auto;
}
.middleNew {
  width: 100vw;
  position: relative;
  margin-top: -15px;
}
.middleTop {
  position: absolute;
  top: 3%;
  left: 50%;
  margin-left: -580px;
}
.topDiving {
  position: relative;
  width: 100vw;
}
.middle {
  position: absolute;
  top: 18%;
  left: 50%;
  margin-left: -240px;
  z-index: 100;
}
.bgsamll {
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -760px;
}
.swiped {
  position: absolute !important;
  top: 32.5%;
  left: 20%;
  width: 627px;
}
.new {
  position: absolute;
  top: 28%;
  right: 16%;
  width: 28%;
}
.fixedImg {
  position: fixed;
  right: 0;
  top: 25%;
  z-index: 100;
}
.sixteen {
  position: fixed;
  right: 0;
  top: 10%;
  z-index: 10000;
}
.qrcodeFixed {
  position: fixed;
  right: 0;
  top: 20%;
  z-index: 10000;
  background: url("../assets/down.png") no-repeat center;
  height: 550px;
  width: 240px;
}
.qrcodeContentFixed {
  display: flex;
  flex-direction: column;
  align-content: center;
}
#ios_btnFixed {
  top: 300px;
  width: 160px;
  height: 50px;
  position: absolute;
  z-index: 22;
  margin-left: 17%;
  cursor: pointer;
  background: url("../assets/ios.jpg") no-repeat center;
  background-size: 100% 100%;
}
#android_btnFixed {
  top: 360px;
  width: 160px;
  height: 50px;
  position: absolute;
  z-index: 22;
  margin-left: 17%;
  cursor: pointer;
  background: url("../assets/安卓.jpg") no-repeat center;
  background-size: 100% 100%;
}
#QRcodeImg1Fixed {
  top: -188px;
  height: 140px;
  width: 140px;
  background: url("/static/img/btn_ios.png") no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  margin-left: calc(50% - 70px);
  display: block;
}
#QRcodeImg2Fixed {
  top: -247px;
  height: 140px;
  width: 140px;
  background: url("../assets/btn_android.png") no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  margin-left: calc(50% - 70px);
  display: none;
}
/* ios下载二维码 */
#ios_btnFixed:hover #QRcodeImg1Fixed {
  display: block;
}
/* 安卓下载二维码 */
#android_btnFixed:hover #QRcodeImg2Fixed {
  display: block;
}

.qrcode {
  background: url("../assets/middle.png") no-repeat center;
  background-size: 100% 100%;
  height: 203px;
  width: 480px;
  position: absolute;
  top: 600px;
  margin-left: calc(50% - 240px);
}
.qrcodeContent {
  display: flex;
  flex-direction: column;
  align-content: center;
}
#ios_btn {
  top: 65px;
  width: 160px;
  height: 50px;
  position: absolute;
  z-index: 22;
  margin-left: 50%;
  cursor: pointer;
  background: url("../assets/btn_ios.png") no-repeat center;
  background-size: 100% 100%;
}
#android_btn {
  top: 125px;
  width: 160px;
  height: 50px;
  position: absolute;
  z-index: 22;
  margin-left: 50%;
  cursor: pointer;
  background: url("../assets/btn_android.png") no-repeat center;
  background-size: 100% 100%;
}
#QRcodeImg1 {
  top: -11px;
  height: 127px;
  width: 127px;
  background: url(/static/img/ios.6f2f040.png) no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  margin-left: calc(50% - 238px);
  display: block;
}
#QRcodeImg2 {
  top: -70px;
  height: 127px;
  width: 127px;
  background: url(/static/img/ios.6f2f040.png) no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  margin-left: calc(50% - 238px);
  display: none;
}
/* ios下载二维码 */
#ios_btn:hover #QRcodeImg1 {
  display: block;
}
/* 安卓下载二维码 */
#android_btn:hover #QRcodeImg2 {
  display: block;
}
.tittle01 {
  position: absolute;
  top: 3%;
  left: 50%;
  margin-left: -580px;
}
.el-tabs__item.is-active {
  color: #fff;
}
.el-tabs__item {
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 35px;
  font-weight: 500;
  color: #fff;
  position: relative;
}
.el-carousel__button {
  background: url("../assets/select.png") no-repeat;
}
.el-table {
  position: relative;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  max-width: 100%;
  font-size: 22px;
  color: #fff;
}
/*表格背景颜色 */
.el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}
.el-table th,
.el-table tr,
.el-table td {
  background-color: transparent !important;
}
.el-table__header-wrapper {
  height: 50px;
}
.tableTransparent,
.el-table tr {
  height: 60px;
  font-size: 22px;
  color: #fff;
}
::-webkit-scrollbar {
  width: 13px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #e5e5e5;
  border-radius: 8px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #a9a9a9;
}
::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}
* {
  scrollbar-color: #e5e5e5 #f7f7f9;
  /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin;
  /* 滚动条宽度有三种：thin、auto、none */
}
/*  */
.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px dashed #fff !important;
}
.el-table::before {
  height: 0 !important;
}

.table > tbody > tr:hover {
  background-color: red;
  color: #ffffff;
}
.lunarDiv {
  position: relative;
  width: 100vw;
  margin-top: -15px;
}
.swiped2 {
  position: absolute !important;
  width: 84%;
  top: 26%;
  margin: 0 8%;
}
.el-carousel__arrow {
  display: none;
}
.el-tabs__content {
  margin-top: -60px;
}
.el-tabs__header {
  background-position-y: 50px !important;
  background-image: url("../assets/zhishi01.png");
  background-repeat: no-repeat;
}
.el-tabs__nav {
  width: 100%;
}
/* tab切換樣式 */
.el-tabs__item {
  width: 250px;
  height: 80px;
  text-align: center;
  font-family: "Times New Roman", Times, serif !important;
  font-size: 45px !important;
  color: #fff !important;
}
.el-tabs__item.is-active {
  color: #fff !important;
}
.el-tabs__active-bar {
  background-color: transparent;
  height: 36px;
  width: 100% !important;
  background-color: transparent !important;
  height: 0;
}
.el-tabs__nav-wrap {
  height: 80px;
}
.tabs1 {
  background: url("../assets/zhishi01.png") no-repeat;
}
.tabs2 {
  background: url("../assets/zhishi02.png") no-repeat;
}
.el-tabs__nav-wrap::after {
  background-color: transparent;
  height: 0px;
  background-color: transparent !important;
}
.el-tabs__item:hover {
  color: #fff;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: transparent !important;
}
.tableTransparent,
.el-table tr {
  cursor: pointer;
}
.el-carousel__button {
  height: 30px;
  width: 30px;
  background: url("../assets/zdw.png") no-repeat;
  background-color: transparent !important;
}
.el-carousel__indicators--outside .el-carousel__indicator:hover button {
  opacity: 1;
  background: url("../assets/zdwed.png") no-repeat;
}
/* .is-active {
  background:url('../assets/zdwed.png') no-repeat;
} */
.el-carousel__indicators--outside button {
  opacity: 1;
}
.leftIcon {
  width: 60px;
  height: 76px;
  position: absolute;
  top: 44%;
  left: 5.5%;
  z-index: 100;
}
.rightIcon {
  width: 60px;
  height: 76px;
  position: absolute;
  top: 44%;
  right: 5.5%;
  z-index: 100;
}
.el-carousel__indicators--outside {
  display: none;
}
.indicatorUl li {
  list-style: none;
  padding: 0 15px;
}
.indicatorUl {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  top: 70%;
  left: 60%;
  z-index: 100;
  margin-left: -350px;
}
.carouselNews li {
  list-style: none;
  padding: 0 8px;
}
.carouselNews {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  top: 70%;
  left: 30%;
}
/* 固定在顶部 */
.Home {
  position: relative;
  width: 100vw;
}
.nav {
  position: fixed;
  top: 0%;
  z-index: 1000;
  width: 100vw;
}
.gankebottom {
  width: 100vw;
  padding: 50px 0;
  background-color: #000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-top: -15px;
}
.btnContent {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size: 18px;
}
.btnContent div {
  display: flex;
  flex-direction: row;
}
.btnContent a {
  color: rgb(250, 171, 25);
  cursor: pointer;
}
.ganke {
  margin-right: 30px;
}
.ganke img {
  width: 152px;
  height: 60px;
}
/* 媒体查询 */
@media screen and (max-width: 2500px) {
  .bgsamll {
    top: 24%;
    width: 90%;
    left: 5%;
    /* margin-left:-700px; */
    margin: 0 auto;
  }
  .carouselNews {
    top: 72%;
    left: 28%;
  }
  .new {
    top: 33%;
    right: 10%;
    width: 31%;
    height: 49%;
  }
  .el-tabs__content {
    margin-top: -77px;
    height: 92%;
  }
  .el-tabs__item {
    font-size: 30px !important;
  }
  .swiped {
    position: absolute !important;
    top: 40%;
    left: 20%;
    width: 30%;
  }
  .indicatorUl {
    top: 65%;
  }
  .middle {
    top: 19%;
  }
  .swiped2 {
    width: 90%;
  }
  .qrcode {
    background: url("../assets/middle.png") no-repeat center;
    background-size: 100% 100%;
    height: 203px;
    width: 480px;
    position: absolute;
    top: 690px;
    margin-left: calc(50% - 240px);
  }
  .qrcodeContent {
    display: flex;
    flex-direction: column;
    align-content: center;
  }
  #ios_btn {
    top: 65px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_ios.png") no-repeat center;
    background-size: 100% 100%;
  }
  #android_btn {
    top: 125px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_android.png") no-repeat center;
    background-size: 100% 100%;
  }
  #QRcodeImg1 {
    top: -11px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: block;
  }
  #QRcodeImg2 {
    top: -70px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: none;
  }
  /* ios下载二维码 */
  #ios_btn:hover #QRcodeImg1 {
    display: block;
  }
  /* 安卓下载二维码 */
  #android_btn:hover #QRcodeImg2 {
    display: block;
  }
}
@media screen and (max-width: 1920px) {
  .bgsamll {
    top: 24%;
    width: 90%;
    left: 5%;
    /* margin-left:-700px; */
    margin: 0 auto;
  }
  .carouselNews {
    top: 76%;
    left: 28%;
  }
  .new {
    top: 33%;
    right: 10%;
    width: 31%;
  }
  .el-tabs__content {
    margin-top: -77px;
    height: 92%;
  }
  .el-tabs__item {
    font-size: 30px !important;
  }
  .swiped {
    position: absolute !important;
    top: 38%;
    left: 18%;
    width: 627px;
  }
  .indicatorUl {
    top: 72%;
  }
  .middle {
    top: 18%;
  }
  .swiped2 {
    width: 84%;
  }
  .qrcode {
    background: url("../assets/middle.png") no-repeat center;
    background-size: 100% 100%;
    height: 203px;
    width: 480px;
    position: absolute;
    top: 600px;
    margin-left: calc(50% - 240px);
  }
  .qrcodeContent {
    display: flex;
    flex-direction: column;
    align-content: center;
  }
  #ios_btn {
    top: 65px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_ios.png") no-repeat center;
    background-size: 100% 100%;
  }
  #android_btn {
    top: 125px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_android.png") no-repeat center;
    background-size: 100% 100%;
  }
  #QRcodeImg1 {
    top: -11px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: block;
  }
  #QRcodeImg2 {
    top: -70px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: none;
  }
  /* ios下载二维码 */
  #ios_btn:hover #QRcodeImg1 {
    display: block;
  }
  /* 安卓下载二维码 */
  #android_btn:hover #QRcodeImg2 {
    display: block;
  }
}
@media screen and (max-width: 1800px) {
  .bgsamll {
    top: 24%;
    width: 90%;
    left: 5%;
    margin: 0 auto;
  }
  .carouselNews {
    top: 76%;
    left: 28%;
  }
  .new {
    top: 33%;
    right: 10%;
    width: 31%;
  }
  .el-tabs__content {
    margin-top: -77px;
    height: 92%;
  }
  .el-tabs__item {
    font-size: 30px !important;
  }
  .swiped {
    position: absolute !important;
    top: 38%;
    left: 18%;
    width: 627px;
  }
  .indicatorUl {
    top: 74%;
  }
  .middle {
    top: 17%;
  }
  .swiped2 {
    width: 84%;
  }
  .qrcode {
    background: url("../assets/middle.png") no-repeat center;
    background-size: 100% 100%;
    height: 203px;
    width: 480px;
    position: absolute;
    top: 525px;
    margin-left: calc(50% - 240px);
  }
  .qrcodeContent {
    display: flex;
    flex-direction: column;
    align-content: center;
  }
  #ios_btn {
    top: 65px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_ios.png") no-repeat center;
    background-size: 100% 100%;
  }
  #android_btn {
    top: 125px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_android.png") no-repeat center;
    background-size: 100% 100%;
  }
  #QRcodeImg1 {
    top: -11px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: block;
  }
  #QRcodeImg2 {
    top: -70px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: none;
  }
  /* ios下载二维码 */
  #ios_btn:hover #QRcodeImg1 {
    display: block;
  }
  /* 安卓下载二维码 */
  #android_btn:hover #QRcodeImg2 {
    display: block;
  }
}
@media screen and (max-width: 1600px) {
  .bgsamll {
    top: 24%;
    width: 90%;
    left: 5%;
    margin: 0 auto;
  }
  .carouselNews {
    top: 78%;
    left: 28%;
  }
  .new {
    top: 33%;
    right: 8%;
    width: 32%;
  }
  .el-tabs__content {
    margin-top: -77px;
    height: 92%;
  }
  .el-tabs__item {
    font-size: 30px !important;
  }
  .swiped {
    position: absolute !important;
    top: 35%;
    left: 15%;
    width: 627px;
  }
  .indicatorUl {
    top: 80%;
  }
  .middle {
    top: 16%;
  }
  .swiped2 {
    width: 84%;
  }
  .qrcode {
    background: url("../assets/middle.png") no-repeat center;
    background-size: 100% 100%;
    height: 203px;
    width: 480px;
    position: absolute;
    top: 444px;
    margin-left: calc(50% - 240px);
  }
  .qrcodeContent {
    display: flex;
    flex-direction: column;
    align-content: center;
  }
  #ios_btn {
    top: 65px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_ios.png") no-repeat center;
    background-size: 100% 100%;
  }
  #android_btn {
    top: 125px;
    width: 160px;
    height: 50px;
    position: absolute;
    z-index: 22;
    margin-left: 50%;
    cursor: pointer;
    background: url("../assets/btn_android.png") no-repeat center;
    background-size: 100% 100%;
  }
  #QRcodeImg1 {
    top: -11px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: block;
  }
  #QRcodeImg2 {
    top: -70px;
    height: 127px;
    width: 127px;
    background: url(/static/img/ios.6f2f040.png) no-repeat center;
    background-size: 100% 100%;
    position: absolute;
    margin-left: calc(50% - 238px);
    display: none;
  }
  /* ios下载二维码 */
  #ios_btn:hover #QRcodeImg1 {
    display: block;
  }
  /* 安卓下载二维码 */
  #android_btn:hover #QRcodeImg2 {
    display: block;
  }
}
</style>
<style>
.el-dialog{
    background: #000 !important;
   
}
.el-dialog__body {
 color:#f7f7f9 !important;
 letter-spacing: 0.5px;
 padding-top:10px;
 padding-bottom:30px;
}
.el-dialog__title {
  color:#f7f7f9 !important;
}
.el-dialog__headerbtn .el-dialog__close{
  color:#fff;
  font-size:26px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue